import { ModalContext } from 'app/app';
import axios from 'axios';
import { FieldInput } from 'components/fieldInput';
import { ViewContext } from 'components/lib';
import { classOptions, vehiclesBodytype } from 'data';
import { Form, Formik } from 'formik';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import loaderImage from './images/loader.gif';
import styles from './styles.module.scss';
import InputUtils from 'helpers/inputUtils';

const normalizeClassValueId = (value) => {
  if (!value) return '1';
  const normalized = String(value).toLowerCase();

  if (normalized === '2h' || normalized === '2g') return '2b';
  if (normalized === '9') return '8';
  if (
    ['1', '2a', '2b', '3', '4', '5', '6', '7', '8'].includes(normalized)
  ) {
    return normalized;
  }

  return '1';
};

export function VehicleModal(props) {
  const { id: company_id } = useParams();
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const [stated_value, setStatedValue] = useState('');

  const inputUtils = new InputUtils();
  const handleChangeStatedValue = (event, handleChange) => {
    handleChange(event);
    event.target.value = event.target.value
      .replaceAll(/\D/g, '')
      .replace(/\?.*/g, ".'");
    setStatedValue(inputUtils.currency(event.target.value));
  };

  useEffect(() => {
    if (modal.data && modal.data.stated_value) {
      setStatedValue(inputUtils.currency(modal.data.stated_value));
    } else {
      setStatedValue('');
    }
  }, [modal]);

  const firstValidationSchema = Yup.object().shape({
    vin: Yup.string()
      .matches(/^[A-Z0-9\s]*$/, 'VIN must be all in uppercase')
      .matches(
        /^(\S+$)/,
        '* This field cannot contain only blankspaces'
      ),
  });

  const secondValidationSchema = Yup.object().shape({
    year: Yup.number()
      .required('This field is required!'),
    make: Yup.string().required('This field is required!'),
    model: Yup.string().required('This field is required!'),
    stated_value: Yup.string().required('This field is required!'),
    loss_payee: Yup.string(),
  });

  async function getVehicleData(vin) {
    var year;
    var type;
    var model;
    var make;
    var class_value;

    const existingVin =
      modal?.data?.vin || modal?.data?.VIN || modal?.data?.['VIN Number'];
    if (modal?.mode === 'edit' && existingVin && vin === existingVin) {
      return {
        type: modal?.data?.type,
        year: modal?.data?.year ?? '',
        model: modal?.data?.model ?? '',
        make: modal?.data?.make ?? '',
        class_value: modal?.data?.class_value ?? modal?.data?.class ?? '',
      };
    }

    await axios
      .get(
        `https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`
      )
      .then((r) => {
        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Model Year') {
            year = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Make') {
            make = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Model') {
            model = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (r.data.Results[i].Variable === 'Vehicle Type') {
            type = r.data.Results[i].Value;
          }
        }

        for (let i = 0; i < r.data.Results.length; i++) {
          if (
            r.data.Results[i].Variable ===
            'Gross Vehicle Weight Rating From'
          ) {
            class_value = r.data.Results[i].ValueId;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return {
      type,
      year:
        year !== null
          ? year
          : modal.data && modal.data.year
          ? modal.data.year
          : '',
      model:
        model !== null
          ? model
          : modal.data && modal.data.model
          ? modal.data.model
          : '',
      make:
        make !== null
          ? make
          : modal.data && modal.data.make
          ? modal.data.make
          : '',
      class_value:
        class_value !== null
          ? class_value
          : modal.data && (modal.data.class_value || modal.data.class)
          ? modal.data.class_value || modal.data.class
          : '',
    };
  }

  /*   const yearOptions20Years = [
    { value: "2004", label: "2004" },
    { value: "2005", label: "2005" },
    { value: "2006", label: "2006" },
    { value: "2007", label: "2007" },
    { value: "2008", label: "2008" },
    { value: "2009", label: "2009" },
    { value: "2010", label: "2010" },
    { value: "2011", label: "2011" },
    { value: "2012", label: "2012" },
    { value: "2013", label: "2013" },
    { value: "2014", label: "2014" },
    { value: "2015", label: "2015" },
    { value: "2016", label: "2016" },
    { value: "2017", label: "2017" },
    { value: "2018", label: "2018" },
    { value: "2019", label: "2019" },
    { value: "2020", label: "2020" },
    { value: "2021", label: "2021" },
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
  ]; */

  return (
    <Fragment>
      {modal.name === 'vehicle_modal' && modal.stage === 1 && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === 'edit' ? 'Edit ' : 'Add '}
                Vehicle
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={firstValidationSchema}
                initialValues={{
                  vin:
                    modal.data && modal.data['VIN']
                      ? modal.data['VIN']
                      : '',
                }}
                onSubmit={async (values, { setErrors }) => {
                  setLoading(true);
                  const existingVin =
                    modal?.data?.vin ||
                    modal?.data?.VIN ||
                    modal?.data?.['VIN Number'];
                  if (
                    modal?.mode === 'edit' &&
                    existingVin &&
                    values.vin === existingVin
                  ) {
                    setLoading(false);
                    setModal({
                      name: 'vehicle_modal',
                      stage: 2,
                      mode: modal.mode,
                      data: { ...modal.data, vin: values.vin },
                      action: modal.action,
                    });
                    return;
                  }
                  const res = await getVehicleData(values.vin);

                  if (
                    modal.type === 'trailer' &&
                    res.type === 'TRUCK'
                  ) {
                    setLoading(false);

                    return setErrors({
                      vin: 'You are trying to add a vin that belongs to a VEHICLE under the trailers section. Please add under the vehicles section.',
                    });
                  }

                  if (
                    modal.type === 'vehicle' &&
                    res.type === 'TRAILER'
                  ) {
                    setLoading(false);

                    return setErrors({
                      vin: 'You are trying to add a vin that belongs to a TRAILER under the vehicles section. Please add under the trailers section.',
                    });
                  }

                  setLoading(false);
                  setModal({
                    name: 'vehicle_modal',
                    stage: 2,
                    mode: modal.mode,
                    data: { ...modal.data, ...res, vin: values.vin },
                    action: modal.action,
                  });
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="vin"
                          type="text"
                          label="VIN"
                          placeholder="VIN"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.vin}
                          touched={touched.vin}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            loading
                              ? { cursor: 'default' }
                              : { cursor: 'pointer' }
                          }
                        >
                          {loading ? (
                            <img
                              src={loaderImage}
                              alt="loader"
                              className={styles.loader}
                            />
                          ) : (
                            'Next'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}

      {modal.name === 'vehicle_modal' && modal.stage === 2 && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === 'edit' ? 'Edit ' : 'Add '}
                Vehicle
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={secondValidationSchema}
                initialValues={{
                  /*                  year:
                    modal.data &&
                    modal.data.year &&
                    yearOptions20Years.find(
                      (value) => value.value === modal.data.year
                    )
                      ? yearOptions20Years.find(
                          (value) => value.value === modal.data.year
                        ).value
                      : yearOptions20Years[0].value, */
                  year:
                    modal.data && modal.data.year
                      ? modal.data.year
                      : '',
                  make: modal.data ? modal.data.make : '',
                  model: modal.data ? modal.data.model : '',
                  stated_value,
                  status: modal.data.active,
                  loss_payee:
                    modal.data && modal.data.loss_payee
                      ? modal.data.loss_payee
                      : '',
                  class: (() => {
                    const normalized = normalizeClassValueId(
                      modal.data?.class_value ?? modal.data?.class ?? ''
                    );
                    return classOptions.find(
                      (predicate) => predicate.value === normalized
                    )
                      ? normalized
                      : classOptions[0].value;
                  })(),
                  bodytype:
                    modal.data && modal.data.bodytype
                      ? modal.data.bodytype
                      : vehiclesBodytype[0].value,
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  if (values.stated_value !== '') {
                    values.stated_value =
                      values.stated_value.replaceAll(/\D/g, '');
                  }

                  if (values.status === 'true') {
                    values.active = true;
                  }

                  if (values.status === 'false') {
                    values.active = false;
                  }

                  if (modal.mode !== 'run_quote') {
                    if (modal.data && modal.data.id) {
                      await axios
                        .patch(`/api/vehicle/${modal.data.id}`, {
                          vin: modal.data.vin,
                          year: values.year,
                          make: values.make,
                          model: values.model,
                          stated_value: values.stated_value,
                          active: values.active,
                          type: 'vehicle',
                          class: values.class,
                          bodytype: values.bodytype,
                          loss_payee: values.loss_payee,
                        })
                        .then((res) => {
                          setLoading(false);
                          setModal({});

                          context.notification.show(
                            'Vehicle updated successfully!',
                            'success',
                            true,
                            'toast',
                            'check-circle'
                          );

                          modal.action();
                        })
                        .catch((err) => {
                          setLoading(false);
                          setModal({});

                          context.notification.show(
                            err.response.data.message,
                            'error',
                            true,
                            'toast',
                            'x-circle'
                          );
                        });
                    } else {
                      await axios
                        .post(`/api/vehicle`, {
                          type: 'vehicle',
                          vin: modal.data.vin ? modal.data.vin : '',
                          year: values.year,
                          make: values.make,
                          model: values.model,
                          stated_value: values.stated_value,
                          loss_payee: values.loss_payee,
                          class: values.class,
                          bodytype: values.bodytype,
                          active: values.active,
                          company_id,
                        })
                        .then((res) => {
                          setLoading(false);
                          setModal({});

                          context.notification.show(
                            'Vehicle created successfully!',
                            'success',
                            true,
                            'toast',
                            'check-circle'
                          );

                          modal.action();
                        })
                        .catch((err) => {
                          setLoading(false);
                          setModal({});
                          console.log(err);

                          context.notification.show(
                            err.response.data.message,
                            'error',
                            true,
                            'toast',
                            'x-circle'
                          );
                        });
                    }
                  } else {
                    await axios
                      .post(`/api/vehicle`, {
                        type: 'vehicle',
                        vin: modal.data.vin ? modal.data.vin : '',
                        year: values.year,
                        make: values.make,
                        model: values.model,
                        stated_value: values.stated_value,
                        loss_payee: values.loss_payee,
                        class: values.class,
                        bodytype: values.bodytype,
                        active: values.active,
                        company_id: modal.data.company_id,
                      })
                      .then((res) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          'Vehicle created successfully!',
                          'success',
                          true,
                          'toast',
                          'check-circle'
                        );

                        modal.action({
                          type: 'vehicle',
                          vin: modal.data.vin ? modal.data.vin : '',
                          year: values.year,
                          make: values.make,
                          model: values.model,
                          stated_value: values.stated_value,
                          class: values.class,
                          bodytype: values.bodytype,
                          active: values.active,
                          company_id: modal.data.company_id,
                        });
                      })
                      .catch((err) => {
                        setLoading(false);
                        setModal({});

                        if (
                          err.response.data.message ===
                          'This VIN already registered.'
                        ) {
                          context.notification.show(
                            'This VIN already registered in this company, to add this vehicle to a quote click in: Select Existing',
                            'error',
                            true,
                            'toast',
                            'x-circle'
                          );
                        } else {
                          context.notification.show(
                            err.response.data.message,
                            'error',
                            true,
                            'toast',
                            'x-circle'
                          );
                        }
                      });
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                  values,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="bodytype"
                          type="select"
                          label="Body Type"
                          placeholder="Insert vehicle's body type"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.bodytype}
                          touched={touched.bodytype}
                          required
                          options={vehiclesBodytype}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <div className={styles.fieldColumn}>
                          <FieldInput
                            id="year"
                            type="text"
                            label="Year"
                            placeholder="Year"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.year}
                            touched={touched.year}
                            required
                            disabled={true}
                          />
                          {values.year && new Date().getFullYear() - Number(values.year) > 23 && (
                            <div className={styles.helperText}>
                              Cover Whale does not accept vehicles/trailers older than 23 years. If you proceed, Cover Whale will be removed from the list of carriers you selected.
                            </div>
                          )}
                        </div>
                        {/*                         <FieldInput
                          id="year"
                          type="select"
                          label="Year"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.year}
                          touched={touched.year}
                          required
                          options={yearOptions20Years}
                        /> */}
                        <FieldInput
                          id="make"
                          type="text"
                          label="Make of Manufacturer"
                          placeholder="Make"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.make}
                          touched={touched.make}
                          required
                          disabled={true}
                        />
                        <FieldInput
                          id="model"
                          type="text"
                          label="Model"
                          placeholder="Model"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.model}
                          touched={touched.model}
                          required
                          disabled={true}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="stated_value"
                          type="currency"
                          label="Value"
                          placeholder="Value"
                          handleChange={(event) => {
                            handleChangeStatedValue(
                              event,
                              handleChange
                            );
                          }}
                          value={stated_value}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.stated_value}
                          touched={touched.stated_value}
                          required
                        />
                        <FieldInput
                          id="loss_payee"
                          type="text"
                          label="Loss Payee"
                          placeholder="Loss Payee"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.loss_payee}
                          touched={touched.loss_payee}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="class"
                          type="select"
                          label="Class"
                          placeholder="Insert vehicle's class"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.class}
                          touched={touched.class}
                          required
                          options={classOptions}
                        />

                        {modal.mode === 'edit' ? (
                          <FieldInput
                            id="status"
                            type="select"
                            label="Status"
                            placeholder="Insert vehicle's status"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.status}
                            touched={touched.status}
                            required
                            options={[
                              {
                                value: true,
                                label: 'Active',
                              },
                              {
                                value: false,
                                label: 'Inactive',
                              },
                            ]}
                          />
                        ) : null}
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            loading
                              ? { cursor: 'default' }
                              : { cursor: 'pointer' }
                          }
                        >
                          {loading ? (
                            <img
                              src={loaderImage}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            'Save'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
